export default "__VITE_ASSET__c40fec6e__"